import axios from '../utils/axiosConfig';
import { apiConfig } from '../config/api.config';
import Cookies from 'js-cookie';
import { logout } from '../utils/ssologin';
import { message } from 'antd';

const getAuthToken = () => {
  return document.cookie.split(';').find(row => row.trim().startsWith('auth_token='))?.split('=')[1];
};

export const userService = {
  // 获取用户姓名列表
  fetchNicknameOptions: async (type) => {
    try {
      const response = await axios.get(apiConfig.getFullURL('/ark/user/nickname_selector'), {
        params: { 
          auth_token: getAuthToken(),
          type:JSON.stringify(type)
        }
      });
      return response.data;
    } catch (error) {
      throw new Error(error.message);
    }
  },

  // 获取用户列表
  fetchUsers: async (params) => {
    try {
      const response = await axios.get(apiConfig.getFullURL('/ark/user/list'), {
        params: {
          ...params,
          auth_token: getAuthToken()
        }
      });
      return response.data;
    } catch (error) {
      throw new Error(error.message);
    }
  },

  // 创建用户
  createUser: async (userData) => {
    try {
      const response = await axios.post(apiConfig.getFullURL('/ark/user/create'), {
        ...userData,
        auth_token: getAuthToken()
      });
      return response.data;
    } catch (error) {
      throw new Error(error.message);
    }
  },

  // 更新用户状态
  updateUserStatus: async (userId, status) => {
    try {
      const response = await axios.post(apiConfig.getFullURL('/ark/user/status'), {
        userId,
        status,
        auth_token: getAuthToken()
      });
      return response.data;
    } catch (error) {
      throw new Error(error.message);
    }
  },

  // 更新用户密码
  updatePassword: async (userId, newPassword) => {
    try {
      const response = await axios.post(apiConfig.getFullURL('/ark/user/updatepwd'), {
        user_id: userId,
        new_password: newPassword,
        auth_token: getAuthToken()
      });
      return response.data;
    } catch (error) {
      throw new Error(error.message);
    }
  },

  // 验证用户信息
  verifyUser: async () => {
    const auth_token = Cookies.get('auth_token');
    if (!auth_token) {
      message.error('未找到登录凭证');
      return { success: false };
    }

    try {
      const response = await axios.get(apiConfig.getFullURL('/auth/get_user'), {
        params: { auth_token }
      });
      if (response.data.code === 0) {
        const { username, type ,userId,nickname } = response.data.data;
        return {
          success: true,
          data: {
            userId : userId,
            name: username,
            nickname: nickname,
            role: type === 0 ? '管理员' : type === 1 ? '内业' : '外业',
            type: type
          }
        };
      } else {
        message.error(response.data.message || '获取用户信息失败');
        return { success: false };
      }
    } catch (error) {
      message.error('验证用户身份失败');
      return { success: false };
    }
  },

  // 用户退出登录
  logout: async () => {
    const auth_token = Cookies.get('auth_token');
    if (!auth_token) {
      message.error('未找到登录凭证');
      return { success: false };
    }

    try {
      await axios.post(apiConfig.getFullURL('/auth/ssologout'), { auth_token });
      logout(); // 清除本地存储的认证信息
      message.success('退出登录成功');
      return { success: true };
    } catch (error) {
      message.error('退出登录失败：' + (error.response?.data?.message || error.message));
      return { success: false };
    }
  }
};